import { render } from "./HospiceDiagnosisTable.vue?vue&type=template&id=1ee4c06a&ts=true"
import script from "./HospiceDiagnosisTable.ts?vue&type=script&lang=ts&external"
export * from "./HospiceDiagnosisTable.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__